import { render, staticRenderFns } from "./ConfigTabPayrollTypes.vue?vue&type=template&id=b00645f4"
import script from "./ConfigTabPayrollTypes.vue?vue&type=script&lang=js"
export * from "./ConfigTabPayrollTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports